import type { NextPage } from 'next'

import { Page } from 'src/components/layouts/Page'
import { ListProjects } from 'src/components/organisms/ListProjects'

import { withAuthRequired } from 'src/utils/auth'

const ListProjectsPage: NextPage = () => {
  return (
    <Page title='Projects'>
      <ListProjects />
    </Page>
  )
}
export default withAuthRequired(ListProjectsPage)
